import { isDeepStrictEqual } from "util";
Object.defEqual = function (targetValue, compareValue) {
    return isDeepStrictEqual(targetValue, compareValue);
};
